'use client';

import { useEffect, useState } from 'react';
import RegionalMap from './RegionalMap';
import GovernmentEngagementCTA from './GovernmentEngagementCTA';

const RegionalOperationsInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <>
      <RegionalMap />
      <GovernmentEngagementCTA />
    </>
  );
};

export default RegionalOperationsInteractive;